export default __webpack_public_path__ + "images/image_upload-6h802.png";